const { Minimatch } = require('minimatch')

class FieldPathMatcher {
    constructor (path) {
        this.globs = [
            new Minimatch(path, {}),
            new Minimatch(`${path}/*`, {})
        ]
    }

    some (target) {
        return this.globs.some((g) => g.match(target))
    }
}

const fieldPathMatchers = {}
const compileFieldPathMatcher = (path) => {
    if (fieldPathMatchers.hasOwnProperty(path)) {
        return fieldPathMatchers[path]
    }

    fieldPathMatchers[path] = new FieldPathMatcher(path)

    return fieldPathMatchers[path]
}

module.exports = compileFieldPathMatcher



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/field-path-matcher.js